import React from 'react';

interface IFullscreenComponentProps {
    children?: React.ReactNode;
}

const FullscreenComponent: React.FunctionComponent = (props: IFullscreenComponentProps) => {
    return (
        <div className='vh-100 vw-100'>
            {props.children}
        </div>
    );
};

export default FullscreenComponent;



// WEBPACK FOOTER //
// ./src/components/FullscreenComponent/FullscreenComponent.tsx